import {
  Pagination,
  Table,
  TableCell,
  TableHeader,
  TableRow,
  Tooltip,
  WrapperFlex,
} from '@unimed-fesp/components';
import format from 'date-fns/format';
import React, { useState } from 'react';
import { MdOutlineManageSearch } from 'react-icons/md';
import { useSelector } from 'react-redux';
import theme from '../../../styles/theme';

import {
  ContainerEmptyContent,
  ContainerTabContent,
  HoverActions,
} from './styles';

import FadeIn from '../../atoms/FadeIn';

import history from '../../../services/history';
import LoadingSpinning from '../../molecules/LoadingSpinning';

const headers = [
  {
    name: 'Contratante',
  },
  {
    name: 'Nome Beneficiário',
  },
  {
    name: 'Grau Parentesco',
  },
  {
    name: 'Modalidade',
  },
  {
    name: 'Termo',
  },
  {
    name: 'Código Beneficiário',
  },
  {
    name: 'Cartão',
  },
  {
    name: 'Data de Nascimento',
  },
  {
    name: 'Data de Exclusão',
  },
  { name: '' },
];

function TabTableBeneficiarios({
  setPaginationParams,
  paginationParams,
  handleChangePage,
}) {
  const { getBeneficiariesNestle } = useSelector((state) => state.beneficiario);

  function handleRender() {
    if (getBeneficiariesNestle.loading) {
      return <LoadingSpinning />;
    }
    if (
      getBeneficiariesNestle.response.data &&
      getBeneficiariesNestle.response.data.length > 0
    ) {
      return (
        <TableLista
          listNameHeaders={headers}
          listas={getBeneficiariesNestle.response}
          setPaginationParams={setPaginationParams}
          paginationParams={paginationParams}
          handleChangePage={handleChangePage}
        />
      );
    }

    if (
      getBeneficiariesNestle.success &&
      getBeneficiariesNestle.response.data.length === 0
    ) {
      return <EmptyContent />;
    }
    return null;
  }

  return handleRender();
}

const TableListaHeader = ({ listNameHeaders }) => {
  return (
    <TableRow>
      {listNameHeaders.map((header) => (
        <TableHeader
          key={header.name}
          minWidth={header.minWidth}
          maxWidth={header.maxWidth}
        >
          {header.name}
        </TableHeader>
      ))}
    </TableRow>
  );
};

const TableLista = ({
  listas,
  listNameHeaders,
  setPaginationParams,
  paginationParams,
  handleDownloadFile,
  tabName,
  handleDropdownItem,
  handleChangePage,
}) => {
  const [listaRowsChecked, setListaRowsChecked] = useState([]);

  return (
    <>
      <FadeIn height="auto">
        <Table head={<TableListaHeader listNameHeaders={listNameHeaders} />}>
          {listas.data.map((lista) => (
            <TableContent
              key={lista.codeCard}
              lista={lista}
              setListaRowsChecked={setListaRowsChecked}
              listaRowsChecked={listaRowsChecked}
              handleDownloadFile={handleDownloadFile}
              tabName={tabName}
              handleDropdownItem={handleDropdownItem}
            />
          ))}
        </Table>
      </FadeIn>
      {listas.totalCount > 10 && (
        <Pagination
          total={listas.totalCount}
          paginationParams={paginationParams}
          setPaginationParams={setPaginationParams}
          callbackChangePage={handleChangePage}
        />
      )}
    </>
  );
};

const TableContent = ({ lista }) => {
  const [hoverAction, setHoverAction] = useState(false);

  function handleMouseEnterHover(e) {
    setHoverAction(!hoverAction);
  }
  function handleMouseLeaveHover(e) {
    if (hoverAction) setHoverAction(!hoverAction);
  }

  const formatDate = (date) => {
    const dataFormated = date
      ? format(new Date(date), 'dd/MM/yyyy', {
          timeZone: 'America/Sao_Paulo',
        })
      : '';
    return dataFormated;
  };

  const formatDegreeOfKinship = (degreeOfKinship) => {
    const replacements = {
      '5 - FilhoUniversitario': '5 - Filho\nUniversitario',
      '88 - FilhoTutelaCURAT': '88 - Filho\nTutela Curatela',
      '17 - OutrosDependentes': '17 - Outros\nDependentes',
      '20 - FilhoAdotivoUniv': '20 - Filho\nAdotivo Univ',
      '89 - FilhoTutelaUNIV': '89 - Filho\nTutela Univ',
    };

    return replacements[degreeOfKinship] || degreeOfKinship;
  };

  return (
    <TableRow
      onMouseEnter={handleMouseEnterHover}
      onMouseLeave={handleMouseLeaveHover}
      key={lista.code_card}
    >
      <TableCell
        width={115}
      >{`${lista.contractorCode}  - ${lista.contractorName}`}</TableCell>
      <TableCell width={140}>{lista.beneficiaryName}</TableCell>
      <TableCell width={110}>
        {formatDegreeOfKinship(lista.degreeOfKinship)}
      </TableCell>
      <TableCell width={115}>{lista.modality}</TableCell>
      <TableCell width={70}>{lista.term}</TableCell>
      <TableCell width={118}>{lista.codeTotvs}</TableCell>
      <TableCell width={148}>{lista.codeCard}</TableCell>
      <TableCell width={115}>{formatDate(lista.beneficiaryBirthday)}</TableCell>
      <TableCell width={100}>
        {formatDate(lista.beneficiaryExcludeDate)}
      </TableCell>
      <TableCell minWidth={30} maxWidth={30}>
        <WrapperFlex alignCenter justifySpaceEvenly>
          <Tooltip
            background={theme.greenDefault}
            color={theme.bgWhite}
            text="Detalhes"
            position="bottom"
          >
            <HoverActions
              onClick={() =>
                history.push(`/novo/beneficiarios-nestle/${lista.codeCard}`)
              }
            >
              <MdOutlineManageSearch size="19" color={theme.colorGray} />
            </HoverActions>
          </Tooltip>
        </WrapperFlex>
      </TableCell>
      {/*  <TableCell width={10}>
         <Tooltip
          background={theme.greenDefault}
          color={theme.bgWhite}
          text="Informações de Beneficiário"
          position="left"
        >
        <HoverActions onClick={() => console.log(lista.codeCard)}>
          <MdOutlineManageSearch size="16" color={theme.colorGray} />
        </HoverActions>
        </Tooltip>
      </TableCell> */}
    </TableRow>
  );
};

const EmptyContent = () => (
  <WrapperFlex fullHeight justifyCenter alignCenter>
    <ContainerEmptyContent>Nenhum registro localizado</ContainerEmptyContent>
  </WrapperFlex>
);

/* const TableListaActions = ({ handleDownloadFile }) => {
  return (
    <WrapperFlex alignCenter justifySpaceEvenly>
      <DownloadMassaInicial
        onClick={() => handleDownloadFile('termo_responsabilidade')}
      >
        <HoverActions data-tip="Baixar termo de reponsabilidade">
          <FaFileDownload size="22" color={theme.colorGray} />
        </HoverActions>
      </DownloadMassaInicial>
      <DownloadMassaInicial onClick={() => handleDownloadFile('massa_inicial')}>
        <HoverActions data-tip="Baixar massa inicial">
          <MdFileDownload size="22" color={theme.colorGray} />
        </HoverActions>
      </DownloadMassaInicial>
      <ReactTooltip
        className="extraClass"
        delayHide={1000}
        effect="solid"
        backgroundColor={theme.greenDefault}
        textColor="#FFF"
        place="bottom"
      />
    </WrapperFlex>
  );
}; */

export default TabTableBeneficiarios;
